import { withCompInfo } from '@wix/editor-elements-integrations'
import { HtmlComponentDefinition, HtmlComponentProps } from './HtmlComponent'

const OLD_STATIC_DOMAIN = 'static.wix.com'
const STATIC_DOMAIN = 'static.wixstatic.com'

const POSSIBLE_PROTOCOLS = ['ftp:', 'http:', 'https:']

const DOMAIN_PATTERN = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/im
const DOMAIN_REG_EXP = new RegExp(DOMAIN_PATTERN.source)

const SANDBOX = 'allow-same-origin allow-forms allow-popups allow-modals allow-scripts allow-pointer-lock'

const extractDomain = (url: string): string => {
	const domain = url.match(DOMAIN_REG_EXP)
	return domain?.[0] || ''
}

const getInternalUrl = (url: string, staticHTMLComponentUrl: string): string => {
	const domain = extractDomain(url)

	// check if url starts with html/ - then prepend staticHTMLComponentUrl
	const startsWithHtml = url.startsWith('html/') ? `${staticHTMLComponentUrl}${url}` : false

	// check if url includes old static domain and replace if it does with staticHTMLComponentUrl
	const includesOldDomain = url.includes(OLD_STATIC_DOMAIN) ? url.replace(domain, staticHTMLComponentUrl) : false

	// check if url include static domain and replace if it does with staticHTMLComponentUrl
	const includesDomain = url.includes(STATIC_DOMAIN) ? url.replace(domain, staticHTMLComponentUrl) : false

	return startsWithHtml || includesDomain || includesOldDomain || url
}

const setProtocol = (url: string, staticHTMLComponentUrl: string): string => {
	// here we set base protocol - check unit tests to understand
	const protocol = url.startsWith('https') ? 'https' : staticHTMLComponentUrl.startsWith('https') ? 'https:' : 'http:'

	// here we check if the given protocol is valid
	const alreadySet = !POSSIBLE_PROTOCOLS.includes(protocol)

	// we split protocol from the rest of the url
	const link = url.split('//')[1]

	/**
	 * if protocol is already set or same as given - return untouched
	 * else return given protocol with link
	 */
	return alreadySet ? url : `${protocol}//${link}`
}

export const props = withCompInfo<HtmlComponentProps, HtmlComponentDefinition>()(
	[
		'compData',
		'topology',
		// @ts-ignore - Remove once useSandboxInHTMLComp is added to the compInfo
		'useSandboxInHTMLComp',
	],
	({
		compData,
		topology,
		// @ts-ignore - Remove once useSandboxInHTMLComp is added to the compInfo
		useSandboxInHTMLComp,
	}) => {
		const { url = '', sourceType = 'nonexternal', scrolling = false, title = '', allowFullScreen } = compData
		const { staticHTMLComponentUrl } = topology

		const sandbox = useSandboxInHTMLComp ? SANDBOX : false

		const allow = allowFullScreen ? 'fullscreen' : false

		const modifiedUrl = sourceType === 'external' ? url : getInternalUrl(url, staticHTMLComponentUrl)
		const iframeUrl = setProtocol(modifiedUrl, staticHTMLComponentUrl)

		return {
			url: iframeUrl,
			...(allow ? { allow } : {}),
			...(scrolling ? { scrolling } : {}),
			...(sandbox ? { sandbox } : {}),
			...(title ? { title } : {}),
		}
	}
)
